import { S as Swiper } from './swiper-core-B0IA3Ohb.js';
import { N as Navigation } from './navigation-gIhQEyYP.js';
import { A as A11y } from './a11y-BSOb6_-2.js';
import './create-element-if-not-defined-DJqdjQL6.js';

class FeaturedProducts extends HTMLElement {
  swiper = this.querySelector('.swiper');
  nextButton = this.querySelector('.swiper-button-next');
  prevButton = this.querySelector('.swiper-button-prev');

  connectedCallback() {
    this.swiperInstance = new Swiper(this.swiper, {
      modules: [A11y, Navigation],
      slidesPerView: 1.4,
      spaceBetween: 1,
      loop: true,
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
      breakpoints: {
        768: {
          slidesPerView: 3.2,
        },
        1024: {
          slidesPerView: 3.6,
        },
      },
    });
  }
}

customElements.define('featured-products', FeaturedProducts);
